import { render, staticRenderFns } from "./Provenance.vue?vue&type=template&id=d75290ee&"
import script from "./Provenance.vue?vue&type=script&lang=js&"
export * from "./Provenance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports